import { createContext, useContext } from 'react';

import type { ClipItem } from 'bundles/enterprise-collections/components/CollectionItem';

export type EnterpriseCurriculumClipsContextType = {
  clipsLoading: boolean;
  clips?: ClipItem[];
};

const EnterpriseCurriculumClipsContext = createContext<EnterpriseCurriculumClipsContextType>({
  clipsLoading: false,
  clips: [],
});

export const useCurriculumClips = () => useContext(EnterpriseCurriculumClipsContext);

export default EnterpriseCurriculumClipsContext;
